export class Year {
  year: string;
  oldyear: any;
  calendar_type: string;
    start_date: string;
    end_date: string;
    year_status: string;
    row_id: string;
    creation_user: string;
    creation_ip: string;
    created_at: string;
  showDeletedOnly: boolean;

    constructor(oldyear: any,year: string, calendar_type: string, start_date: string, end_date: string, year_status: string ) {
        this.oldyear = oldyear;
        this.year = year;
        this.calendar_type = calendar_type;
        this.start_date = start_date;
        this.end_date = end_date;
        this.year_status = year_status;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/years/year.ts